import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import { StaticImageData } from 'next/image';
import {
    CarsFullyRefurbished,
    CarInspectedBySylndr,
    CarLegalitiesChecked,
    CarNintyDays,
    CarNoAccidents,
    CarOwnedBySylndr,
    CarSevenDaysReturn,
    CarOwnedByCertifiedDealer,
} from 'public/Images';

export interface CarIncludeType {
    index: number;
    title: {
        ar: string;
        en: string;
    };
    subTitle: {
        ar: string;
        en: string;
    };
    points: {
        ar: string;
        en: string;
    }[];
    icon: StaticImageData;
}

export const AvailableCarIncludes: CarIncludeType[] = [
    {
        index: 0,
        title: {
            en: 'Car owned by Sylndr',
            ar: 'العربية مملوكة لسيلندر ',
        },
        subTitle: {
            en: 'Fully documented and registered under Sylndr’s name',
            ar: 'موثقة بالكامل و باسم سيلندر.',
        },
        points: [],
        icon: CarOwnedBySylndr,
    },
    {
        index: 1,
        title: {
            en: 'Fully renewed and serviced',
            ar: 'تم التجديد و عمل الصيانات',
        },
        subTitle: {
            en: 'These cars are high-quality, fully renewed, backed by Sylndr, and need no extra spending',
            ar: 'العربية متجددة بالكامل علشان تبقى بأفضل حالة ممكنة.',
        },
        points: [
            {
                en: 'Ensuring the car requires zero repair costs.',
                ar: 'التأكد أن العربية لا تحتاج أي مصاريف نهائياً.',
            },
            {
                en: 'Damaged parts replaced',
                ar: 'استبدال القطع التالفة.',
            },
            {
                en: 'Some parts are under warranty if needed, using the best methods and materials',
                ar: 'دهان بعض القطع إن تطلب الامر و بيكون بأفضل الطرق و الخامات.',
            },
        ],
        icon: CarsFullyRefurbished,
    },
    {
        index: 2,
        title: {
            en: '7-day return policy',
            ar: '7 أيام سياسة استرجاع',
        },
        subTitle: {
            en: 'If you change your mind, you can return the car within 7 days <span class="text-caption2 text-gray-400">(T&Cs apply)</span>',
            ar: 'لو غيرت رأيك، تقدر ترجّع العربية في خلال ٧ أيام. <span class="text-caption2 text-gray-400">(تطبق الشروط والأحكام)</span>',
        },
        points: [
            {
                en: 'Easy and guaranteed 7-day return, no questions asked',
                ar: 'استرجاع سهل ومضمون لمدة ٧ أيام من غير أي أسئلة.',
            },
        ],
        icon: CarSevenDaysReturn,
    },
    {
        index: 3,
        title: {
            en: '90-day warranty from Sylndr',
            ar: 'ضمان 90 يوم من سيلندر',
        },
        subTitle: {
            en: 'Comprehensive warranty covers you against major repairs <span class="text-caption2 text-gray-400">(T&Cs apply)</span>',
            ar: 'ضمان شامل يغطيك ضد الأعطال و الإصلاحات الأساسية. <span class="text-caption2 text-gray-400">(تطبق الشروط والأحكام)</span>',
        },
        points: [
            {
                en: 'For all renewed parts',
                ar: 'كل القطع المجددة.',
            },
            {
                en: 'For any failures in essential parts',
                ar: 'أي أعطال في القطع الأساسية.',
            },
        ],
        icon: CarNintyDays,
    },
    {
        index: 4,
        title: {
            en: 'Inspected by Sylndr',
            ar: 'مفحوصة من سيلندر',
        },
        subTitle: {
            en: 'Sylndr inspects the car to ensure quality',
            ar: 'سيلندر بتفحصلك العربية علشان تتآكد من الجودة.',
        },
        points: [
            {
                en: 'Full inspection covers over 200 checkpoints',
                ar: 'فحص شامل يغطي أكتر من 200 نقطة.',
            },
            {
                en: 'Car condition documented with photos and reports',
                ar: 'توثيق حالة العربية بالصور والتقارير.',
            },
        ],
        icon: CarInspectedBySylndr,
    },
    {
        index: 5,
        title: {
            en: 'Legal ownership guaranteed',
            ar: 'نضمن قانونية ملكية العربية',
        },
        subTitle: {
            en: 'Every car is reviewed to make sure it’s free from legal or accident issues',
            ar: 'بنراجع كل عربية علشان نتأكد إنها خالية من أي مشاكل قانونية أو حوادث.',
        },
        points: [
            {
                en: 'Ownership confirmation',
                ar: 'تأكيد الملكية.',
            },
            {
                en: 'Making sure all legal documents are valid',
                ar: 'التأكد إن كل المستندات القانونية سليمة.',
            },
        ],
        icon: CarLegalitiesChecked,
    },
    {
        index: 6,
        title: {
            en: 'Free from major accidents',
            ar: 'بدون حوادث مؤثرة',
        },
        subTitle: {
            en: "Every car is reviewed to confirm it's free of major accidents or structural damage",
            ar: 'بنراجع كل عربية ونتأكد إنها خالية من الحوادث الكبيرة أو أي أضرار هيكلية.',
        },
        points: [
            {
                en: 'Comprehensive check for major accidents or structural damage',
                ar: 'فحص شامل للحوادث الكبيرة أو التلف الهيكلي.',
            },
        ],
        icon: CarNoAccidents,
    },
    {
        index: 7,
        title: {
            en: 'Certified Partner from sylndr',
            ar: 'شريك معتمد من سيلندر',
        },
        subTitle: {
            en: "We verify the Partner's identity through:",
            ar: 'إحنا بنتأكد من هوية الشريك عن طريق:',
        },
        points: [
            {
                en: 'Commercial registration and tax card',
                ar: 'السجل التجاري والبطاقة الضريبية.',
            },
            {
                en: 'Address confirmation',
                ar: 'تأكيد عنوانه.',
            },
        ],
        icon: CarOwnedByCertifiedDealer,
    },
];

export const CarIncludesMap: Record<CarTypesEnum, number[]> = {
    [CarTypesEnum.CERTIFIED]: [0, 1, 2, 3, 4, 5, 6],
    [CarTypesEnum.LITE]: [0, 2, 4, 5, 6],
    [CarTypesEnum.Dealer]: [7, 4, 5],
};
